import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';

import { Listino } from '../models/listino.model';
import { ListinoNazionale } from '../models/listinoNazionale.model';
import { MandatoDiPagamento } from '../models/mandatoDiPagamento.model';


@Injectable({
  providedIn: 'root',
})
export class MandatiDiPagamentoService{
  apiUrl: string = environment.apiUrl+"mdp";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

  get(): Observable<any> {
    const headers = {
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }

  getOfOda(idOda:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    
    return this.http.get(this.apiUrl+"?oda="+idOda, httpOptions);
  }

  getById(id:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+id, httpOptions);
  }

  
  modifica(mdp:MandatoDiPagamento): Observable<any> {
    const headers = {
      //  'Authorization': `Bearer ${token}`,
      };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+mdp.id, mdp, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificaMandatoDiPagamento', []))
    );
  }
  
  crea(mdp:MandatoDiPagamento): Observable<any> {
    const headers = {
      //  'Authorization': `Bearer ${token}`,
      };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, mdp, httpOptions);
  }

  elimina(idMdp:string): Observable<any> {
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idMdp, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminaMdp', []))
    );
  }

  private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };

}